import * as Yup from "yup";

export const getFormSchema = (t) => {
	return Yup.object().shape({
		password: Yup.string()
			.required(t("fill_required_fields"))
			.min(8, t("password_has_to_be_at_least_n_characters_long", { min: 8 })),
		passwordConfirm: Yup.string()
			.required(t("fill_required_fields"))
			.oneOf([Yup.ref("password")], t("passwords_has_to_match")),
	});
};
